import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components'
import SVG from "react-inlinesvg";
import { Link } from 'react-router-dom'
import { device } from "../media"
import LoginInfoButton from './LoginInfoButton';
import LanguageSelectionButton from './LanguageSelectionButton';
import searchIcon from '../img/icons/icon_search.svg'
import HeaderButton from './HeaderButton';
import AccToolbox from './AccToolbox';
import { getTabindex } from '../helper/tabindexHelper';

const Header = () => {
    const { t } = useTranslation()
    const themeContext = useContext(ThemeContext);

    return (
        <>
            {themeContext.accToolbar && <AccToolbox />}
            <Wrapper>
                <Content>
                    {
                        themeContext.header.link ?
                            <ExternalLink target="blank" href={themeContext.header.link} tabIndex={getTabindex("logo")}>
                                <Logo src={themeContext.logoImage} alt={"Logo " + themeContext.header.title} />
                            </ExternalLink>
                            :
                            <ExternalLink href={"/"} tabIndex={getTabindex("logo")}>
                                <Logo src={themeContext.logoImage} alt={"Logo " + themeContext.header.title} />
                            </ExternalLink>
                    }

                    <ButtonWrapper>
                        {
                            themeContext.additionalLanguages.length > 0 &&
                            <LanguageSelectionButton />
                        }
                        <IconWrapper href={`${themeContext.directory}/search`} aria-label={t('search_content')} tabIndex={getTabindex("searchIcon")}>
                            <Icon src={searchIcon} />
                        </IconWrapper>
                        <LoginInfoButton />
                    </ButtonWrapper>
                </Content>
            </Wrapper>

        </>
    )
}


export default Header

const Wrapper = styled.div`
    height: 76px;  
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    @media ${device.mobile}{
        height: 56px;
    }
`

const Content = styled.span`
    width: 960px;
    display: flex;
    justify-content: space-between;
    @media ${device.tablet}{
        width: 820px;
    }
`

const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    @media ${device.tablet}{
        margin-right: 12px;
    }
    @media ${device.mobile}{
        margin-right: 12px;
    }
`

const StyledLink = styled(Link)`
`

const ExternalLink = styled.a`
`

const IconWrapper = styled.a`
    display: flex;
    align-items: center;
    &:hover {
        opacity: 0.65;
    }
`

const Icon = styled(SVG)`    
    &:last-of-type {
        margin-left: 9px;
    }
    &:hover {
        opacity: 0.65;
    }

`

const Logo = styled.img`
    height: 36px;

    @media ${device.tablet}{
        margin-left: 12px;
    }
    @media ${device.mobile}{
        margin-left: 12px;
        height: 32px;
    }
`
